import styled from 'styled-components';
import { Checkbox as AntCheckbox } from 'antd';
import { Palette } from '../utils';

export const Checkbox = styled(AntCheckbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${Palette.HAZY_BLUE};
    border-color: ${Palette.HAZY_BLUE} !important;
  }

  .ant-checkbox-inner {
    border: 2px solid ${Palette.HAZY_BLUE};
  }

  .ant-checkbox-checked::after {
    border-color: ${Palette.HAZY_BLUE} !important;
    border: 2px solid ${Palette.HAZY_BLUE};
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: ${Palette.HAZY_BLUE};
  }

  && .ant-checkbox-checked .ant-checkbox-inner {
    border-color: ${Palette.HAZY_BLUE} !important;
  }

  && .ant-checkbox-checked:hover .ant-checkbox-inner {
    border-color: ${Palette.HAZY_BLUE} !important;
  }

  && .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner {
    border-color: ${Palette.HAZY_BLUE} !important;
  }

  && .ant-checkbox-checked.ant-checkbox-focused .ant-checkbox-inner {
    border-color: ${Palette.HAZY_BLUE} !important;
    box-shadow: none !important;
  }

  .ant-checkbox-checked:hover .ant-checkbox-inner,
  .ant-checkbox-indeterminate:hover .ant-checkbox-inner {
    border-color: ${Palette.HAZY_BLUE} !important;
  }

  &:hover .ant-checkbox-checked .ant-checkbox-inner,
  &:hover .ant-checkbox-indeterminate .ant-checkbox-inner {
    border-color: ${Palette.HAZY_BLUE} !important;
  }

  .ant-checkbox-checked.ant-checkbox-focused .ant-checkbox-inner,
  .ant-checkbox-indeterminate.ant-checkbox-focused .ant-checkbox-inner,
  .ant-checkbox-checked .ant-checkbox-input:focus + .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${Palette.HAZY_BLUE} !important;
    box-shadow: none !important;
  }

  &.ant-checkbox-wrapper:hover .ant-checkbox-inner,
  &:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${Palette.HAZY_BLUE} !important;
    box-shadow: none !important;
  }

  .ant-checkbox-wrapper-focused .ant-checkbox-inner,
  .ant-checkbox-focused .ant-checkbox-inner {
    box-shadow: none !important;
  }
`;

export default Checkbox;
